export const defaultDoorHeight = 2560;
export const defaultDoorWidth = 920;
export const defaultTopBottomFrameWidth = 860;
export const defaultSideFrameWidth = 31;
export const defaultUHandleConnectorXPosition = 52;
export const defaultUHandleZPosition = 46;
export const defaultUHandleHeight = 700;
export const defaultLockHeight = 750;
export const defaultJHandleYPosition = 1000;
export const defaultJHandleZPosition = 0.036;
export const defaultLockHandleYPosition = 1.05;
export const singleDoubleDoorShiftValue = 0.1;
